/**
 * Stacking order for OneBUTTON commerce + finance partner modals (antd Modal zIndex).
 * Commerce hub Products/Quotes must stay below nested sync flows opened from within them.
 */
export const OBD_COMMERCE_HUB_Z = 10050;

/** Gap when Products is opened on top of an already-open Quotes modal (keepQuotesOpen). */
export const OBD_COMMERCE_HUB_PRODUCTS_ABOVE_QUOTES_GAP = 10;

/**
 * Create-contract confirmation opened from the Quotes card (often nested inside commerce hub + editor overlays).
 * Use the same band as other nested Trinity prompts ({@link OBD_FINANCE_PARTNER_PROGRESS_Z} and ViewTrinity nested ~11060).
 */
export const OBD_QUOTES_CONTRACT_CONFIRM_Z = 11070;

/** Checklist + IGS/LightReach lead table + generic lead sync + credit check shell */
export const OBD_FINANCE_PARTNER_SYNC_Z = 10065;

/** Confirm-which-FPs prompt stacked above the lead table / checklist */
export const OBD_FINANCE_PARTNER_CONFIRM_Z = OBD_FINANCE_PARTNER_SYNC_Z + 10;

/** Progress modal + credit iframe — above sync tables and Generate Quote (10080) */
export const OBD_FINANCE_PARTNER_PROGRESS_Z = 10090;

/** Sunny opportunity assistant drawer — must stay above floating section rail/header chrome. */
export const OBD_OPPORTUNITY_ASSISTANT_DRAWER_Z = 12000;

/** DashboardModal shell (Other layout options, Gemini results, etc.). */
export const OBD_DASHBOARD_MODAL_Z = 12000;

/** Tree cutting scenarios popup — portaled above oneDRAW chrome (context menu + dashboard). */
export const OBD_EDITOR_TREE_CUTTING_MODAL_Z = 11000;

/** Financing options grid — default band below editor overlays. */
export const OBD_PRICING_GRID_MODAL_Z = 9600;

/** Financing grid when a parent editor modal (e.g. tree cutting) remains open underneath. */
export const OBD_PRICING_GRID_NESTED_MODAL_Z = OBD_EDITOR_TREE_CUTTING_MODAL_Z + 250;

/** Gap above an open Financing options modal when Products / Quotes are opened from its toolbar (viewer $ flow). */
export const OBD_COMMERCE_HUB_ABOVE_PRICING_GRID_GAP = 100;

/**
 * Products / Quotes z-index.
 * When `stackedAboveQuotes` is true, returns a value strictly above the Quotes band so Products
 * never hides behind the Quotes popup.
 */
export function resolveCommerceHubModalZ(
    pricingGridModalOpen: boolean,
    pricingGridZIndex: number,
    stackedAboveQuotes: boolean,
): number {
    const base = OBD_COMMERCE_HUB_Z;
    const withStack = stackedAboveQuotes ? base + OBD_COMMERCE_HUB_PRODUCTS_ABOVE_QUOTES_GAP : base;
    if (!pricingGridModalOpen) return withStack;
    const abovePricing = pricingGridZIndex + OBD_COMMERCE_HUB_ABOVE_PRICING_GRID_GAP;
    return Math.max(withStack, stackedAboveQuotes ? abovePricing + OBD_COMMERCE_HUB_PRODUCTS_ABOVE_QUOTES_GAP : abovePricing);
}

/** AI design EPC comparison — standalone (drawer / catalog list). */
export const OBD_AI_DESIGNS_EPC_MODAL_Z = 10240;

/** EPC when opened from a {@link OBD_DASHBOARD_MODAL_Z} parent — must stack above it. */
export const OBD_AI_DESIGNS_EPC_NESTED_MODAL_Z = OBD_DASHBOARD_MODAL_Z + 100;

/** EPC when opened from tree cutting scenarios — stack above {@link OBD_EDITOR_TREE_CUTTING_MODAL_Z}. */
export const OBD_AI_DESIGNS_EPC_TREE_CUTTING_NESTED_MODAL_Z = OBD_EDITOR_TREE_CUTTING_MODAL_Z + 100;
